import { AuthorizationErrorBox } from "common/ui-components";
import {
  PermissionsOperator,
  PermissionsSpec,
  usePermissionsChecker
} from "core/auth/usePermissionsChecker";
import { PropsWithChildren } from "react";

import { Permission } from "../types/permission.enum";

interface Props {
  permissions?: PermissionsSpec;
  operator?: PermissionsOperator;
  customPermissionsCheck?: (userPermissions: Permission[]) => boolean;
}

export const Authorized = ({
  permissions,
  operator,
  children,
  customPermissionsCheck
}: PropsWithChildren<Props>) => {
  const hasPermissions = usePermissionsChecker();

  if (!hasPermissions(permissions, operator, customPermissionsCheck)) {
    return <AuthorizationErrorBox />;
  }

  return <>{children}</>;
};
